/* eslint-disable react/no-danger */
import React, { useState } from 'react';

import { PriceBlock, RadioWithLabel, RadioLabel, RadioButton } from '@hpstellar/core';
import { Dropdown, Button, Typography } from '@hpstellar/core/visId';
import { Info } from '@hpstellar/icons';
import { XFilled } from '@hpstellar/veneer-icons';

import { RenderEspotHtml } from './espot-manager';
import { Helpers } from '../../core/src/helpers';
import { getGTMClickAttributes } from '../../metrics/metrics-helpers';
import { useMSRPProps } from '../../hooks/useProductPrice';

import './instant-ink-plan.less';

export default function InstantInkPlan({ instantinkLogo, ctaText, options, eSpotName }) {
    const [ink, setInk] = useState(null);
    const [expand, setExpand] = useState(false);
    const msrp = useMSRPProps();
    const [selectedType, setSelectedType] = useState(options?.[0]?.id || 'monthly');
    const selectedData = options?.find(option => option.id === selectedType) || {};
    const currentOptions = selectedData?.plans || [];

    const handleSubscriptionChange = type => {
        if (type === selectedType) return;
        setSelectedType(type);
        setInk(null);
    };

    return (
        <div className="instantInkPlan">
            <div className="instantInkPlan-header">
                <div className="banner">
                    <img src={instantinkLogo} alt="instant ink" />

                    {selectedData?.titleMessage && (
                        <Typography className="instantInkPlan-msg" variant="caption">
                            <span dangerouslySetInnerHTML={Helpers.createMarkup(selectedData?.titleMessage)} />
                        </Typography>
                    )}
                </div>

                <Button
                    className="instantInkPlan-details-btn"
                    variation="tertiary"
                    color="dark"
                    size="small"
                    endIcon={expand ? <XFilled size="16" /> : <Info size="s" />}
                    onClick={() => setExpand(!expand)}
                    {...getGTMClickAttributes('linkClick', 'instant-ink', `view-details`)}
                >
                    {expand ? 'Close details' : 'Details'}
                </Button>
            </div>

            <div className="instantInkPlan-body">
                <div className="subscription-wrapper">
                    {options?.map(option => (
                        <RadioWithLabel
                            key={option.id}
                            className="radio-btn-with-label"
                            checked={selectedType === option.id}
                            onClick={() => handleSubscriptionChange(option.id)}
                        >
                            <RadioLabel className="radio-label">
                                <RadioButton className="radio-btn" />
                                <Typography variant="caption">
                                    {option.label}
                                    {option.labelMessage && (
                                        <span className="subscription-promo">
                                            <br />
                                            {option.labelMessage}
                                        </span>
                                    )}
                                </Typography>
                            </RadioLabel>
                        </RadioWithLabel>
                    ))}
                </div>

                <Dropdown
                    className="instantInkPlan-dropdown"
                    label="Ink Plans"
                    options={currentOptions.map(option => ({ label: option.label, value: option.value }))}
                    onChange={val => setInk(val)}
                    variation="form"
                    listProps={{ matchWidth: true }}
                    value={ink}
                    key={selectedType}
                />
            </div>

            <div className="instantInkPlan-footer">
                <div>
                    <Typography className="instantInkPlan-price" weight="700">
                        {!ink && <span className="instantInkPlan-price-label">From</span>}
                        <PriceBlock
                            className="instantInkPlan-price-block"
                            regularPrice={ink || selectedData?.plans?.[0]?.value}
                            salePriceSuffix="/mo."
                            style="right"
                            size="small"
                            weight="700"
                            msrp={msrp}
                        />
                    </Typography>
                </div>
                <div className="instantInkPlan-cta">
                    <Button to={selectedData?.ctaLink} theme="dark" size="small">
                        {ctaText}
                    </Button>
                </div>
            </div>

            <RenderEspotHtml eSpotName={eSpotName} details expand={expand} />
        </div>
    );
}
